
import { Component, Vue } from 'vue-property-decorator';
import { getIntegral, getForRecord } from '@/services/http';
import { dateTimeFormatter, readCookie } from '@/tools/tools';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import IntegralRule from '@/components/rule/integralRule.vue';

@Component({
  components: {
    Header,
    Footer,
    NavMenu,
    IntegralRule
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    }
  }
})
export default class extends Vue {
  loading: boolean = false; // 加载

  activeIndex: number = 1; // 默认1：积分记录，2：兑换记录

  listData: any[] = []; // 积分记录列表

  forData: any[] = []; // 兑换记录列表

  isLoading: boolean = false; // 表格加载

  ruleList: any[] = []; // 积分规则列表

  totalnumber: number = 0; // 总条数

  pageNo: number = 1; // 当前页

  pageSize: number = 10; // 当前条数

  showRule: boolean = false; // 是否显示规则说明

  private created() {
    this.getListData(); // 获取列表数据
  }

  // 积分记录、兑换记录切换
  private changeActiveIndex(index: number) {
    this.activeIndex = index;
    this.pageNo = 1;
    this.pageSize = index === 1 ? 10 : 5;
    this.getListData();
  }

  // 获取列表数据
  private async getListData() {
    const anchor = readCookie('anchor');
    this.listData = [];
    let res: any = {};
    if (this.activeIndex === 1) {
      res = await getIntegral({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        companyId: 1
      });
      if (res.data.code === 100) {
        this.listData = res.data.data.list;
        this.totalnumber = res.data.data.total;
      } else {
        (this as any).$message.error(res.data.message);
      }
    } else if (this.activeIndex === 2) {
      res = await getForRecord({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        src: anchor ? (anchor.src ? anchor.src : 2) : 4
      });
      if (res.data.code === 100) {
        this.forData = res.data.data.list;
        this.totalnumber = res.data.data.total;
      } else {
        (this as any).$message.error(res.data.message);
      }
    }
  }

  // 条数回调
  private handleSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.getListData();
  }

  // 页数回调
  private handleCurrentChange(pageNo: number) {
    this.pageNo = pageNo;
    this.getListData();
  }
}

